import Tooltip from "../tooltip";
import React, { useContext } from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Box, Typography } from "@mui/material";
import { AuthContext } from "../../../contexts/AuthContext";

export default function AvatarHeader({ children, ...props }) {

    const {user} = useContext(AuthContext)

  return (
    <Tooltip title="Conta">
      <Box sx={{display:'flex',alignItems:'center'}}>
        <AccountCircleIcon
          size="small"
          sx={{ ml: 2, color: "#2B3A8B" }}
          {...props}
        ></AccountCircleIcon>
        <Box sx={{marginLeft:'8px'}}>
            <Typography sx={{fontWeight:'bold',fontSize:'0.8rem'}}>
                {user.name} 
            </Typography>
            {/* <Typography sx={{fontSize:'0.7rem',textAlign:'start'}}>
                Dev.
            </Typography> */}
        </Box>
      </Box>
    </Tooltip>
  );
}
